import { ArrowLeft } from "lucide-react";
import { Link } from "wouter";

export default function NotFound() {
  return (
    <section className="not-found section-line">
      <div aria-hidden="true">404</div>
      <div>
        <span className="kicker">Page not found</span>
        <h1>The requested page is outside this partition layout.</h1>
        <p>Return to the Partition Stalls homepage or browse the complete commercial bathroom partition material range.</p>
        <div className="button-row">
          <Link href="/" className="button button--primary"><ArrowLeft aria-hidden="true" /> Return Home</Link>
          <Link href="/bathroom-partitions" className="button button--outline">View Partitions</Link>
        </div>
      </div>
    </section>
  );
}
